import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import interactiveVideoActions from 'redux/actions/interactiveVideoActions'
import { uploadingOverlaySelector } from 'redux/selectors/interactive_video_creation'
import { localize } from 'helpers/translator'
import IVideoUploadingOverlay from 'views/slides/content/interactive_video/overlays/IVideoUploadingOverlay'

class IVideoUploadingOverlayContainer extends PureComponent {

	render() {
		return (
			<IVideoUploadingOverlay
				message={this.props.message}
				buttonLabel={localize('interactive_video_uploadingOverlay_cancelButton')}
				buttonHandler={this.props.actions.uploadVideoCancel}
			/>
		)
	}
}

function mapStateToProps(state) {
	return uploadingOverlaySelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		uploadVideoCancel: interactiveVideoActions.uploadVideoCancel,
	}, dispatch)
}

IVideoUploadingOverlayContainer.propTypes = {
	actions: PropTypes.shape({
		uploadVideoCancel: PropTypes.func.isRequired,
	}),
	message: PropTypes.array,
}

export default connect(mapStateToProps, mapDispatchToProps)(IVideoUploadingOverlayContainer)
